import React from 'react';
import { RightHolderState, InputFieldState } from '../types';
import IdentificationNumberForm from '../IdentificationNumberForm';
import AddressForm from '../AddressForm';
import NameForm from '../NameForm';

/**
 * RightHolderコンポーネント用のPropsです。
 * @interface RightHolderProps
 */
interface RightHolderProps {
  /**
   * 索引
   * @type {number}
   * @memberof RightHolderProps
   */
  index: number;

  /**
   * 権利者
   * @type {string}
   * @memberof RightHolderProps
   */
  rightHolder: RightHolderState;

  /**
   * 権利者を設定する関数
   * @memberof AgencyProps
   */
  onChange: (index: number, updatedAgency: RightHolderState) => void;
}

/**
 * 権利者フォームのコンポーネントです。
 * @param {number} props.index - 索引
 * @param {string} props.rightHolder - その他の委任事項
 * @param {function} props.onChange - その他の委任事項が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - その他の委任事項フォームのJSX要素
 */
const RightHolderForm: React.FC<RightHolderProps> = ({ index, rightHolder, onChange }) => {

  /**
   * 識別番号を更新する関数です。
   * @param {string} identificationNumber - 識別番号
   * @returns {void}
   */
  const updateIdentificationNumber = (identificationNumber: InputFieldState): void => {
    onChange(index, 
      {
        identificationNumber: {
          value: identificationNumber.value,
          errorMessage: identificationNumber.errorMessage
        },
        address: rightHolder.address,
        name: rightHolder.name
      }
    );
  };

  /**
   * 住所又は居所を更新する関数です。
   * @param {InputFieldState} address - 住所又は居所
   * @returns {void}
   */
  const updateAddress = (address: InputFieldState): void => {
    onChange(index, 
      {
        identificationNumber: rightHolder.identificationNumber,
        address: address,
        name: rightHolder.name
      }
    );
  };

  /**
   * 氏名又は名称を更新する関数です。
   * @param {InputFieldState} name - 氏名又は名称
   * @returns {void}
   */
  const updateName = (name: InputFieldState): void => {
    onChange(index, 
      {
        identificationNumber: rightHolder.identificationNumber,
        address: rightHolder.address,
        name: name
      }
    );
  };

  return (
    <>
      <div className="ms-lg-5">
        <IdentificationNumberForm
          identificationNumber={rightHolder.identificationNumber}
          isAgency={false}
          isRequired={false}
          onChange={updateIdentificationNumber}
        />
        <AddressForm
          address={rightHolder.address}
          isAgency={false}
          isRequired={true}
          onChange={updateAddress}
        />
        <NameForm
          name={rightHolder.name}
          isAgency={false}
          isRequired={true}
          onChange={updateName}
        />
        {/* <RepresentativeForm
          representative={rightHolder.representative}
          name={rightHolder.name}
          isProcedureExecutor={false}
          onChange={updateRepresentative}
        /> */}
      </div>
    </>
  );
}

export default RightHolderForm;